// frontend/src/components/Header.jsx
import React, { useState } from "react";
import { HashLink } from 'react-router-hash-link'; // for smooth scrolling to #sections
import { Link } from "react-router-dom"; // keep normal Link for pages without hash

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    const spans = document.querySelectorAll("#menu-btn span");
    if (!isMenuOpen) {
      spans[0].style.transform = "rotate(45deg) translate(5px, 5px)";
      spans[1].style.opacity = "0";
      spans[2].style.transform = "rotate(-45deg) translate(7px, -6px)";
    } else {
      spans[0].style.transform = "none";
      spans[1].style.opacity = "1";
      spans[2].style.transform = "none";
    }
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    const spans = document.querySelectorAll("#menu-btn span");
    spans[0].style.transform = "none";
    spans[1].style.opacity = "1";
    spans[2].style.transform = "none";
  };

  return (
    <header className="fixed top-0 w-full z-50">
      {/* Top Bar */}
      <div id="header" className="w-full bg-gray-100">
        <div className="w-[92%] max-w-[1350px] mx-auto flex flex-wrap items-center justify-between gap-2 md:gap-3 py-1.5 md:py-2">
          {/* Logo */}
          <div className="logo-main flex-shrink-0 pr-1 md:pr-2">
            <img
              src="/img/logobgremo-2.png"
              alt="Drive With Portland Logo"
              className="
                w-[130px] h-auto
                md:w-[190px]
                max-h-[90px] md:max-h-[100px]
                cursor-pointer
                transition-all duration-300
                hover:scale-105
                hover:drop-shadow-lg
                drop-shadow-md
                object-contain
              "
            />
          </div>

          {/* Desktop Info (hidden on mobile) */}
          <div className="hidden md:flex flex-wrap items-center gap-6 lg:gap-10">
            {/* Address */}
            <div className="flex items-center gap-3 min-w-[200px]">
              <div className="w-[40px] h-[40px] border-2 border-[#1d4ed8] text-[#1d4ed8] rounded-full flex items-center justify-center text-[18px]">
                <i className="fa fa-location-dot"></i>
              </div>
              <div className="flex flex-col leading-tight">
                <span className="text-[15px] font-semibold text-[#222]">
                  Glasgow & Neighbourhoods, United Kingdom
                </span>
              </div>
            </div>

            {/* Phone */}
            <div className="flex items-center gap-3 min-w-[200px]">
              <div className="w-[40px] h-[40px] border-2 border-[#1d4ed8] text-[#1d4ed8] rounded-full flex items-center justify-center text-[18px]">
                <i className="fa fa-phone"></i>
              </div>
              <div className="flex flex-col leading-tight">
                <span className="text-[13px] text-[#1d4ed8] font-semibold">
                  Contact:
                </span>
                <a
                  href="tel:+447726778000"
                  className="text-[15px] text-[#222] font-bold"
                >
                  +44 7726 77 8000
                </a>
              </div>
            </div>

            {/* Working Hours */}
            <div className="flex items-center gap-3 min-w-[200px]">
              <div className="w-[40px] h-[40px] border-2 border-[#1d4ed8] text-[#1d4ed8] rounded-full flex items-center justify-center text-[18px]">
                <i className="fa fa-clock"></i>
              </div>
              <div className="flex flex-col leading-tight">
                <span className="text-[13px] text-[#1d4ed8] font-semibold">
                  OPENING HOURS:
                </span>
                <span className="text-[15px] text-[#222] font-semibold">
                  Mon - Fri: 8AM - 8PM
                </span>
                <span className="text-[15px] text-[#222] font-semibold">
                  Sat - Sun: 10AM - 5PM
                </span>
              </div>
            </div>

            {/* Social Icons */}
            <div className="flex items-center gap-3">
              <a
                href="https://www.youtube.com/@DrivewithPortland"
                target="_blank"
                rel="noopener noreferrer"
                className="w-[36px] h-[36px] bg-[#ff0033] text-white rounded-full flex items-center justify-center text-[14px] hover:bg-[#a50d25] transition"
              >
                <i className="fab fa-youtube"></i>
              </a>
              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=drivewithportland@gmail.com"
                target="_blank"
                className="w-[36px] h-[36px] bg-gradient-to-r from-[#ea4335] via-[#fbbc04] to-[#34a853] text-white rounded-full flex items-center justify-center text-[14px] hover:opacity-90 transition"
              >
                <i className="fab fa-google-plus"></i>
              </a>
              <a
                href="https://wa.me/447726778000?text=Hello%20I%20want%20to%20get%20information"
                target="_blank"
                rel="noopener noreferrer"
                className="w-[36px] h-[36px] bg-[#25D366] text-white rounded-full flex items-center justify-center text-[14px] hover:bg-green-500 transition"
              >
                <i className="fab fa-whatsapp"></i>
              </a>
            </div>
          </div>

          {/* Mobile Info */}
          <div className="flex md:hidden items-center gap-2 sm:gap-3">
            <div className="flex items-center gap-1 sm:gap-2">
              <a
                href="tel:+447726778000"
                className="w-[28px] h-[28px] sm:w-[32px] sm:h-[32px] border-2 border-[#1d4ed8] bg-[#1d4ed8] text-white rounded-full flex items-center justify-center text-[12px] sm:text-[14px] hover:bg-white hover:text-[#1d4ed8] transition"
              >
                <i className="fa fa-phone"></i>
              </a>
              <a
                href="tel:+447726778000"
                className="text-[12px] sm:text-[14px] text-[#222] font-bold whitespace-nowrap hover:text-[#1d4ed8] transition hidden xs:block"
              >
                +44 7726 77 8000
              </a>
            </div>

            <div className="flex items-center gap-1 sm:gap-2 border-l border-gray-300 pl-2">
              <a
                href="https://wa.me/447726778000?text=Hello%20I%20want%20to%20get%20information"
                target="_blank"
                rel="noopener noreferrer"
                className="w-[28px] h-[28px] sm:w-[32px] sm:h-[32px] bg-[#25D366] text-white rounded-full flex items-center justify-center text-[12px] sm:text-[14px] hover:bg-green-600 transition"
              >
                <i className="fab fa-whatsapp"></i>
              </a>
              <a
                href="https://www.youtube.com/@DrivewithPortland"
                target="_blank"
                rel="noopener noreferrer"
                className="w-[28px] h-[28px] sm:w-[32px] sm:h-[32px] bg-[#ff0033] text-white rounded-full flex items-center justify-center text-[12px] sm:text-[14px] hover:bg-[#cc0029] transition"
              >
                <i className="fab fa-youtube"></i>
              </a>
              <a
                href="mailto:drivewithportland@gmail.com"
                className="w-[28px] h-[28px] sm:w-[32px] sm:h-[32px] bg-gradient-to-r from-[#ea4335] via-[#fbbc04] to-[#34a853] text-white rounded-full flex items-center justify-center text-[12px] sm:text-[14px] hover:opacity-90 transition hidden sm:block"
              >
                <i className="fab fa-google-plus"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="w-full bg-[#1D4ED8] text-white py-1 border-b border-white/10 shadow-xl">
        <div className="max-w-7xl px-3 sm:px-4 md:px-6 lg:px-2 py-1 flex items-center">
          
          {/* Desktop Menu */}
          <ul className="hidden md:flex items-center space-x-10 lg:space-x-20 font-semibold text-white ml-auto mr-8 lg:mr-12">
            <li>
              <HashLink smooth to="/#hero" className="hover:text-[#FACC15]">
                Home
              </HashLink>
            </li>
            <li>
              <HashLink smooth to="/#about" className="hover:text-[#FACC15]">
                About
              </HashLink>
            </li>
            <li>
              <HashLink smooth to="/#Instructor" className="hover:text-[#FACC15]">
                Join us
              </HashLink>
            </li>
            <li>
              <HashLink smooth to="/#courses" className="hover:text-[#FACC15]">
                Courses
              </HashLink>
            </li>
            <li>
              <HashLink smooth to="/#areas" className="hover:text-[#FACC15]">
                Areas
              </HashLink>
            </li>
            <li>
              <Link to="/pricing" className="hover:text-[#FACC15]">
                Pricing
              </Link>
            </li>
             <li>
              <HashLink smooth to="/#faq" className="hover:text-[#FACC15]">
                F&Qs
              </HashLink>
            </li>
             <li>
              <HashLink smooth to="/#faq" className="hover:text-[#FACC15]">
                T&C
              </HashLink>
            </li>

            <li>
              <HashLink smooth to="/#contact" className="hover:text-[#FACC15]">
                Contact
              </HashLink>
            </li>
          </ul>

          <HashLink
            smooth
            to="/#contact"
            className="hidden md:block px-4 lg:px-5 py-2 lg:py-2.5 rounded-xl font-semibold text-[#1D4ED8] bg-[#FACC15] shadow-lg hover:bg-white transition"
          >
            Book Now
          </HashLink>

          {/* Mobile Menu Button */}
          <button
            id="menu-btn"
            className="md:hidden flex flex-col space-y-1.5 ml-auto"
            onClick={toggleMenu}
          >
            <span className="w-6 h-[3px] bg-white rounded-full transition-transform"></span>
            <span className="w-6 h-[3px] bg-white rounded-full transition-opacity"></span>
            <span className="w-6 h-[3px] bg-white rounded-full transition-transform"></span>
          </button>
        </div>

        {/* Mobile Menu Dropdown */}
        <div
          id="mobile-menu"
          className={`md:hidden bg-[#1D4ED8] border-t border-white/10 py-3 px-4 transition-all duration-300 ${
            isMenuOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
          } overflow-hidden`}
        >
          <div className="flex flex-col space-y-3">
            <HashLink
              smooth
              to="/#hero"
              className="text-white hover:text-[#FACC15] transition-colors px-2 py-2 rounded-lg hover:bg-white/10"
              onClick={closeMenu}
            >
              Home
            </HashLink>
            <HashLink
              smooth
              to="/#about"
              className="text-white hover:text-[#FACC15] transition-colors px-2 py-2 rounded-lg hover:bg-white/10"
              onClick={closeMenu}
            >
              About
            </HashLink>
            <HashLink
              smooth
              to="/#courses"
              className="text-white hover:text-[#FACC15] transition-colors px-2 py-2 rounded-lg hover:bg-white/10"
              onClick={closeMenu}
            >
              Courses
            </HashLink>
            <HashLink
              smooth
              to="/#areas"
              className="text-white hover:text-[#FACC15] transition-colors px-2 py-2 rounded-lg hover:bg-white/10"
              onClick={closeMenu}
            >
              Areas
            </HashLink>
            <Link
              to="/pricing"
              className="text-white hover:text-[#FACC15] transition-colors px-2 py-2 rounded-lg hover:bg-white/10"
              onClick={closeMenu}
            >
              Pricing
            </Link>
            <HashLink
              smooth
              to="/#contact"
              className="text-white hover:text-[#FACC15] transition-colors px-2 py-2 rounded-lg hover:bg-white/10"
              onClick={closeMenu}
            >
              Contact
            </HashLink>

             <HashLink
              smooth
              to="/#Instructor"
              className="text-white hover:text-[#FACC15] transition-colors px-2 py-2 rounded-lg hover:bg-white/10"
              onClick={closeMenu}
            >
              Join Us
            </HashLink>


             <HashLink
              smooth
              to="/#faq"
              className="mt-3 px-5 py-3 rounded-xl font-semibold text-center text-[#1D4ED8] bg-[#FACC15] shadow-lg hover:bg-white transition"
              onClick={closeMenu}
            >
              F&Q
            </HashLink>
             <HashLink
              smooth
              to="/#faq"
              className="mt-3 px-5 py-3 rounded-xl font-semibold text-center text-[#1D4ED8] bg-[#FACC15] shadow-lg hover:bg-white transition"
              onClick={closeMenu}
            >
              T&C
            </HashLink>
            <HashLink
              smooth
              to="/#contact"
              className="mt-3 px-5 py-3 rounded-xl font-semibold text-center text-[#1D4ED8] bg-[#FACC15] shadow-lg hover:bg-white transition"
              onClick={closeMenu}
            >
              Book Now
            </HashLink>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;